module.exports = __webpack_public_path__ + "static/media/DSCF9037.6e637d75.JPG";